// ESM shim for `react-native-css-interop/dist/doctor.js`. The
// upstream file is a TypeScript-emitted CJS module (`"use strict";
// Object.defineProperty(exports, "__esModule", ...)`) that ALSO
// contains a JSX literal (the `<react-native-css-interop-jsx-pragma-check
// />` probe used to verify the JSX runtime was swapped). Neither
// Vite's Rollup CJS plugin nor esbuild's TSX loader can apply both
// the CJS→ESM rewrite AND the JSX transform on the same file —
// excluding one breaks the other. The prod build leaves raw
// `exports.verifyJSX = ...` statements in the bundle, producing
// `ReferenceError: exports is not defined` at runtime.
//
// `vite.config.ts` aliases the file path to this shim. The shim
// preserves the same named-export contract that
// `nativewind/dist/stylesheet.js` relies on:
//
//   verifyJSX()  — true when the JSX runtime hosts the NativeWind
//                  custom element pragma. Always true on the web
//                  build because `vite.config.ts` sets
//                  `jsxImportSource: 'nativewind'` for every file.
//   verifyFlag() — reads the `--css-interop-<name>` CSS variable
//                  that the runtime stamps onto `<html>` to confirm
//                  the css-interop runtime mounted.
//   verifyData() — reads the bare `--css-interop` variable for the
//                  same purpose.

const computedStyles =
  typeof window !== 'undefined'
    ? window.getComputedStyle(window.document.documentElement)
    : ({ getPropertyValue: () => 'asdf' } as Pick<CSSStyleDeclaration, 'getPropertyValue'>);

export function verifyJSX(): boolean {
  // The original probe rendered a custom JSX element and compared
  // its return value to `true`, relying on the NativeWind pragma's
  // shape. On Vite (web) we statically guarantee the JSX runtime
  // via `react({ jsxImportSource: 'nativewind' })`, so the check
  // is redundant — always return true.
  return true;
}

export function verifyFlag(name?: string, value = 'true'): boolean {
  if (typeof window === 'undefined') return true;
  return (
    computedStyles.getPropertyValue(name ? `--css-interop-${name}` : '--css-interop') === value
  );
}

export function verifyData(): boolean {
  if (typeof window === 'undefined') return true;
  return computedStyles.getPropertyValue('--css-interop') !== '';
}
